module.exports = __webpack_public_path__ + "img/2025-10.5df62aaa.jpg";